// extracted by mini-css-extract-plugin
export default {"formItem":"SWCreateCompanyModal_formItem__-C7cD"};